export const ANALYSIS_DATA_PROJECTION = 'analysis_data_status'

const PRODUCT_PAGES = ['dashboard', 'history_monitor', 'core_index', 'first_book']

const CORE_INDEX_NAMES = {
  '000001.SH': '上证指数',
  '000300.SH': '沪深300',
  '000688.SH': '科创50',
  '000852.SH': '中证1000',
  '000905.SH': '中证500',
  '399001.SZ': '深证成指',
  '399006.SZ': '创业板指'
}

function isObject(value) {
  return Boolean(value && typeof value === 'object' && !Array.isArray(value))
}

export function validateAnalysisDataProjection(payload, expectedPage) {
  const status = payload && payload.analysis_data_status
  const valid = Boolean(
    isObject(payload) &&
    payload.projection === ANALYSIS_DATA_PROJECTION &&
    PRODUCT_PAGES.includes(payload.product_page) &&
    (!expectedPage || payload.product_page === expectedPage) &&
    payload.read_only === true &&
    payload.provider_free === true &&
    payload.writes_database === false &&
    payload.writes_cache === false &&
    payload.writes_history_rows === false &&
    payload.creates_or_mutates_queue === false &&
    payload.claims_or_refreshes_lease === false &&
    payload.starts_worker === false &&
    payload.starts_scheduler === false &&
    payload.starts_download === false &&
    payload.sends_notification === false &&
    payload.legacy_payload_loaded === false &&
    payload.legacy_hddb_bundle_loaded === false &&
    payload.legacy_queue_root3_loaded === false &&
    payload.existing_route_reused === true &&
    payload.new_http_endpoint_created === false &&
    isObject(status) &&
    ['ready', 'warming', 'stale', 'unavailable', 'quality_blocked'].includes(String(status.status || '')) &&
    isObject(status.items_by_code)
  )
  if (!valid) throw new Error('分析数据轻量状态合同校验失败')
  return payload
}

export function productStatusLabel(status) {
  return ({
    ready: '分析可用',
    warming: '正在准备',
    stale: '分析可用（数据降级）',
    unavailable: '暂不可完整分析',
    quality_blocked: '需要处理'
  })[String(status || '').toLowerCase()] || '状态待确认'
}

export function productStatusTagType(status) {
  const value = String(status || '').toLowerCase()
  if (value === 'ready') return 'success'
  if (['warming', 'stale'].includes(value)) return 'warning'
  if (['unavailable', 'quality_blocked'].includes(value)) return 'danger'
  return 'info'
}

export function derivedStatusLabel(status) {
  return ({
    derived_ready: '可用于分析',
    derived_stale: '可降级分析',
    source_insufficient: '源数据准备中',
    quality_blocked: '数据质量需处理'
  })[String(status || '').toLowerCase()] || '待确认'
}

export function derivedStatusTagType(status) {
  const value = String(status || '').toLowerCase()
  if (value === 'derived_ready') return 'success'
  if (['derived_stale', 'source_insufficient'].includes(value)) return 'warning'
  if (value === 'quality_blocked') return 'danger'
  return 'info'
}

export function derivedSourceNote(item) {
  if (!item || item.status !== 'derived_stale') return ''
  const source = item.canonical_source_freq || item.source
  const label = source === 'daily' ? '日线' : (source === '5m' ? '5分钟' : '数据')
  const cutoff = item.source_coverage_to
  return `来源${label}待增补，${cutoff ? `截至 ${cutoff}` : '截止日期待确认'}`
}

export function analysisStatusRows(payload) {
  const status = (payload && payload.analysis_data_status) || {}
  const byCode = status.items_by_code || {}
  const scopeItems = (((payload || {}).scope || {}).items) || []
  const scopeByCode = scopeItems.reduce((result, item) => {
    const code = String((item || {}).ts_code || '').trim().toUpperCase()
    if (code) result[code] = item
    return result
  }, {})
  return Object.keys(byCode).sort().map(code => {
    const item = byCode[code] || {}
    const scope = scopeByCode[code] || {}
    return {
      ...item,
      ts_code: code,
      name: scope.name || item.name || CORE_INDEX_NAMES[code] || '',
      zone: scope.zone || item.zone || ''
    }
  })
}
